import React, { useEffect, useState } from 'react';
import EditableGiftCard from '../EditableGiftCard';
import AddGiftCard from './AddGiftCard';


const PDFViewer = ({ 
  currentPdf, 
  currentUrl,
  gifts, 
  loading, 
  selectedSource, 
  setSelectedSource, 
  fetchRandomGift, 
  handleStatusUpdate,
  setGifts
}) => {
  const [showAddGift, setShowAddGift] = useState(false);
  const [stats, setStats] = useState(null);
  const [viewMode, setViewMode] = useState('pdf'); // 'pdf' or 'html'

  const toggleViewMode = () => {
    setViewMode(viewMode === 'pdf' ? 'html' : 'pdf');
  };

  const renderLeftPanel = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center h-full text-gray-500">
          Loading...
        </div>
      );
    }

    if (viewMode === 'pdf') {
      if (currentPdf) {
        return (
          <iframe
            src={currentPdf}
            className="w-full h-full border-0"
            title="PDF Viewer"
          />
        );
      } else {
        return (
          <div className="flex items-center justify-center h-full text-gray-500">
            <div className="text-center">
              <p className="mb-2">No PDF available for this document</p>
              <p className="text-sm">Switch to HTML view to see the original content</p>
            </div>
          </div>
        );
      }
    } else {
      // HTML view
      if (currentUrl) {
        return (
          <iframe
            src={currentUrl}
            className="w-full h-full border-0"
            title="HTML Content"
          />
        );
      } else {
        return (
          <div className="flex items-center justify-center h-full text-gray-500">
            No HTML content available
          </div>
        );
      }
    }
  };

  return (
    <div className="flex h-screen">
      {/* Left Side Panel with View Toggle */}
      <div className="w-1/2 p-4 bg-gray-100">
        <div className="mb-2 flex justify-end">
          <button
            onClick={toggleViewMode}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Switch to {viewMode === 'pdf' ? 'HTML' : 'PDF'} View
          </button>
          <a className="px-4 py-2 text-white rounded bg-blue-300 hover:bg-blue-400" href={currentUrl} target="_blank">Open In New Window</a>
        </div>
        <div className="h-[calc(100%-3rem)] rounded-lg overflow-hidden shadow-lg bg-white">
          {renderLeftPanel()}
        </div>
      </div>

      {/* Gift Details - Right Side */}
      <div className="w-1/2 p-4 overflow-auto">
        <div className="sticky top-0 z-10 bg-white pb-4 mb-4 border-b">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold">Related Gifts</h2>
            <div className="flex items-center gap-2">
              <select
                value={selectedSource}
                onChange={(e) => setSelectedSource(e.target.value)}
                className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500"
              >
                <option value="all">All Sources</option>
                <option value="sitemap">Sitemap Crawler</option>
                <option value="high_prof">News Crawler</option>
              </select>
              <button
                onClick={fetchRandomGift}
                disabled={loading}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
              >
                {loading ? 'Loading...' : 'Next Random Document'}
              </button>
            </div>
          </div>
          <p className="text-sm text-gray-600 mt-2">
            Found {gifts.length} gift{gifts.length !== 1 ? 's' : ''} for this document
          </p>
        </div>

        {gifts.length > 0 ? (
          <div className="space-y-4">
            {gifts.map(gift => (
              <EditableGiftCard 
                key={gift.id} 
                gift={gift} 
                gifts={gifts}
                setGifts={setGifts}
                handleStatusUpdate={handleStatusUpdate}
              />
            ))}
          </div>
          
        ) : (
          <div className="text-center py-8 text-gray-500">
            No gifts available
          </div>
        )}
        <div className="mb-8">
          <button
            onClick={() => setShowAddGift(true)}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
          >
            Add New Gift
          </button>
        </div>

        {showAddGift && (
          <div className="mb-8">
            <AddGiftCard
              onGiftAdded={(newGift) => {
                newGift.status = 'approved'
                // Add the new gift to the gifts list
                setGifts(prevGifts => [...prevGifts, newGift]);
                setShowAddGift(false);
              }}
              onCancel={() => setShowAddGift(false)}
              currentPdfUrl={currentUrl}
              currentPdfSource={currentPdf}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PDFViewer;
